import throttle from '~/utils/events/throttle';
import fetchListMore from './asyncActions/fetchListMore';
import {getState, SubscribedComponent} from './Store/index';
import State, {StateListDataItem} from './Store/State';
import listStateToQueryString from './utils/listStateToQueryString';

/**
 * Component Properties
 */
interface AbstractListViewProps
{
	[key: string]: void;
}

/**
 * Component State
 */
interface AbstractListViewState
{
	/** Результат выборки */
	items: StateListDataItem[];
	/** Сколько осталось незагруженных записей */
	itemsLeft: number;
	/** Смещение для следующей группы записей */
	nextItemsOffset: number;
	/** Осуществляется загрузка данных с сервера? */
	loading: boolean;
}

/**
 * Абстрактный компонент режима списка.
 */
abstract class AbstractListView
	extends SubscribedComponent<State, AbstractListViewProps, AbstractListViewState>
{
	/**
	 * Абстрактный компонент режима списка.
	 */
	public constructor( props: AbstractListViewProps )
	{
		super( props );
		
		this.onWindowScroll = throttle(
			this.onWindowScroll,
		);
	}
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		window.addEventListener( 'scroll', this.onWindowScroll );
	}
	
	/**
	 * Before component will be unmounted and destroyed.
	 */
	public componentWillUnmount(): void
	{
		window.removeEventListener( 'scroll', this.onWindowScroll );
	}
	
	/**
	 * Handle Store changes.
	 */
	protected storeStateChanged(
		{
			common: {loading},
			listData: {items, itemsLeft, nextItemsOffset},
		}: State,
	): void
	{
		if (
			( items === this.state.items )
			&& ( itemsLeft === this.state.itemsLeft )
			&& ( nextItemsOffset === this.state.nextItemsOffset )
			&& ( loading === this.state.loading )
		)
		{
			return;
		}
		
		this.setState( {items, itemsLeft, nextItemsOffset, loading} );
	}
	
	/**
	 * Обработчик прокрутки экрана.
	 */
	private onWindowScroll = async (): Promise<void> =>
	{
		if (
			!this.state.loading
			&& ( this.state.itemsLeft > 0 )
			&& ( window.pageYOffset > (document.documentElement.offsetHeight - window.innerHeight * 2) )
		)
		{
			fetchListMore(
				listStateToQueryString(
					getState().filter,
					this.state.nextItemsOffset,
				),
			);
		}
	}
}

/**
 * Module.
 */
export {
	AbstractListView as default,
	AbstractListViewProps,
	AbstractListViewState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/AbstractListView.ts